<div class="container">
  <h2 class="v4-color-white">
    {{ "General information about the Training" | translator }}
  </h2>

  <div class="row">
    <div class="col-md-3 col-12 my-2">
      <div
        class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
      >
        <span class="sbc-icon sbc-icon-users-alt font3rem"></span>
        <hr class="hr w-75 border-4" />
        <h5 class="text-center p-2">{{ "Training Attendees" | translator }}</h5>
        <h1>{{ data?.stats?.attendees }}</h1>
        <!-- <span>type</span> -->
      </div>
    </div>

    <div class="col-md-3 col-12 my-2">
      <div
        class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
      >
        <span class="sbc-icon sbc-icon-completed font3rem"></span>
        <hr class="hr w-75 border-4" />
        <h5 class="text-center p-2">
          {{ "Completed by Attendees" | translator }}
        </h5>
        <h1>{{ data?.stats?.completed }}</h1>
        <!-- <span>type</span> -->
      </div>
    </div>

    <div class="col-md-3 col-12 my-2">
      <div
        class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
      >
        <span class="sbc-icon sbc-icon-badge-percent font3rem"></span>
        <hr class="hr w-75 border-4" />
        <h5 class="text-center p-2">{{ "Average Percentage" | translator }}</h5>
        <h1>{{ data?.stats?.avg }}%</h1>
        <!-- <span>type</span> -->
      </div>
    </div>
  </div>
</div>

<hr class="hr w-75 border-4 v4-color-white" />

<div class="container py-4">
  <h2 class="v4-color-white">
    {{ "Overall performance level as estimated" | translator }}
  </h2>

  <div
    *ngIf="
      data?.stats &&
      data?.stats?.gradecount &&
      data?.stats?.gradecount.length > 0
    "
    class="row align-items-center"
  >
    <div class="col-7">
      <div class="row">
        <div class="col p-2">
          <div class="card assess-card">
            <table class="table">
              <thead>
                <tr>
                  <th colspan="2">{{ "Training Grade" | translator }}</th>
                  <th colspan="1">{{ "Range" | translator }}</th>
                  <th colspan="1">{{ "Training Users" | translator }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data?.stats?.gradecount">
                  <td><i class="{{ item._id.icon }}"></i></td>
                  <td>{{ item._id.title }}</td>
                  <td>{{ item._id.from }} - {{ item._id.to }}</td>
                  <td *ngIf="item.count">
                    {{
                      (item.count / totalling(data?.stats?.gradecount)) * 100
                        | number : "1.2-2"
                    }}%
                  </td>
                  <td *ngIf="!item.count">N/A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-5 flex justify-content-center p-2">
      <p-chart
        *ngIf="totalGradesData"
        type="pie"
        [data]="totalGradesData"
        [options]="options"
        height="200"
      ></p-chart>
    </div>
  </div>
</div>

<hr class="hr w-75 border-4 v4-color-white" />

<div *ngIf="trainings && trainings.length > 0" class="container">
  <div class="row">
    <div *ngFor="let training of trainings" class="col-md-6 col-12">
      <div class="card assess-card py-4 px-4 my-2">
        <h3 class="v4-color-white">{{ training.title }}</h3>
        <p class="text-white" [innerHTML]="training.description | safeHTML"></p>

        <div class="row align-items-center">
          <div class="col-md-4 col-6 my-2">
            <div
              class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
            >
              <span class="sbc-icon sbc-icon-users-alt font3rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">
                {{ "Training Attendees" | translator }}
              </h5>
              <h1>{{ training.attendees.length }}</h1>
              <!-- <span>type</span> -->
            </div>
          </div>

          <div class="col-md-4 col-6 my-2">
            <div
              class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
            >
              <span class="sbc-icon sbc-icon-completed font3rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">
                {{ "Completed by Attendees" | translator }}
              </h5>
              <h1>{{ training.completed.length }}</h1>
              <!-- <span>type</span> -->
            </div>
          </div>

          <div class="col-md-4 col-6 my-2">
            <div
              class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4"
            >
              <span class="sbc-icon sbc-icon-badge-percent font3rem"></span>
              <hr class="hr w-75 border-4" />
              <h5 class="text-center p-2">
                {{ "Average Percentage" | translator }}
              </h5>
              <h1>{{ training.avg ? training.avg + "%" : "N/A" }}</h1>
              <!-- <span>type</span> -->
            </div>
          </div>

          <div
            *ngIf="training?.gradecount && training?.gradecount.length > 0"
            class="col-7"
          >
            <div class="row">
              <div class="col p-2">
                <div class="card assess-card">
                  <table class="table">
                    <thead>
                      <tr>
                        <th colspan="1">{{ "Training Grade" | translator }}</th>
                        <th colspan="1">{{ "Range" | translator }}</th>
                        <th colspan="1">{{ "Training Users" | translator }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of training?.gradecount">
                        <td>
                          <i class="{{ item._id.icon }}"></i>
                          {{ item._id.title }}
                        </td>
                        <td>{{ item._id.from }} - {{ item._id.to }}</td>
                        <td>
                          {{
                            (item.count / totalling(training?.gradecount)) * 100
                              | number : "1.2-2"
                          }}%
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="training?.gradecount && training?.gradecount.length > 0"
            class="col-5 flex justify-content-center p-2"
          >
            <p-chart
              *ngIf="training.graphData"
              type="doughnut"
              [data]="training.graphData"
              [options]="options"
              height="200"
            ></p-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
